<template>
  <div>
    <embedly-placeholder v-if="showPlaceholder" @click="revealImage" />

    <a v-else :href="embedlyThumbnailUrl" target="_blank" rel="noopener noreferrer">
      <img class="img-fluid" :style="imgStyle" :src="imageSrc" :alt="title">
    </a>
  </div>
</template>

<script>
import EmbedlyPlaceholder from './embedly-placeholder'
import embedlyPrivacyMixin from './embedly-privacy-mixin'

export default {
  components: { EmbedlyPlaceholder },

  mixins: [ embedlyPrivacyMixin],

  props: {
    bypassPlaceholder: {
      type: Boolean,
      required: true
    },
    imgStyle: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      showPlaceholder: this.agraConfiguration.embedly.privacyMode && !this.bypassPlaceholder
    }
  },

  computed: {
    imageSrc() {
      if (this.agraConfiguration.embedly.privacyMode) {
        // Show the image we have downloaded from Embedly via our proxy, if we have it.
        return this.proxiedThumbnailUrl
      } else {
        // Fetch the image from Embedly
        return this.embedlyThumbnailUrl
      }
    }
  },

  methods: {
    revealImage() {
      this.showPlaceholder = false
    }
  }
}
</script>
